//Stick to recommended events (and params) for best reporting results:
//https://support.google.com/analytics/answer/9267735

let analytics = null;

// Wait for Firebase to be ready
if (window.firebaseReady) {
  analytics = window.firebaseAnalytics;
} else {
  window.addEventListener('firebaseReady', () => {
    analytics = window.firebaseAnalytics;
  });
}

function webAnalyticsEvent(eventName, params = {}) {
  if (!analytics) {
    console.warn('Firebase Analytics not initialized yet');
    return;
  }

  try {
    window.logEvent(analytics, eventName, params);
  } catch (e) {
    console.error('Could not fire GA event:', e);
  }
}

function analyticsLogin(method = 'email') {
  webAnalyticsEvent('login', { method });
}

function analyticsSignUp(method = 'email') {
  webAnalyticsEvent('sign_up', { method });
}

function analyticsTutorialBegin() {
  webAnalyticsEvent('tutorial_begin');
}

function analyticsTutorialComplete() {
  webAnalyticsEvent('tutorial_complete');
}

function analyticsSelectContent(content_type, item_id) {
  if (item_id) {
    webAnalyticsEvent('select_content', {
      content_type,
      item_id: item_id.toString()
    });
  }
}

function analyticsScreenView(screenName, screenClass) {
  //page_view is automatically collected on web apps (https://support.google.com/analytics/answer/9234069)
  //but because this is a Single Page App, we disable auto page views (index.html) and use screen_view instead
  webAnalyticsEvent('screen_view', {
    page_title: screenName,
    screen_name: screenName,
    screen_class: screenClass
  });
}

export {
  analyticsLogin,
  analyticsScreenView,
  analyticsSelectContent,
  analyticsSignUp,
  analyticsTutorialBegin,
  analyticsTutorialComplete
};
